import { ITableFilterInputProps } from 'modules';
import React, { FC } from 'react';
import NumberFormat from 'react-number-format';

export const TableFilterInputNumber: FC<ITableFilterInputProps> = (props) => {
  const key = props.paramKey;

  return (
    <div className='TableFilterInputNumber'>
      <NumberFormat
        fixedDecimalScale={false}
        defaultValue={props.params[key]}
        onValueChange={({ floatValue }) => {
          const data = floatValue || 0;
          props.onChange({ [key]: data });
        }}
      />
    </div>
  );
};
